module.exports = __webpack_public_path__ + "static/media/ba.7d6f56d2.svg";